import { render, staticRenderFns } from "./HeaderA.vue?vue&type=template&id=0a6a23ed&scoped=true&"
import script from "./HeaderA.vue?vue&type=script&lang=js&"
export * from "./HeaderA.vue?vue&type=script&lang=js&"
import style0 from "./HeaderA.vue?vue&type=style&index=0&id=0a6a23ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6a23ed",
  null
  
)

export default component.exports